const n = {
  "language-switch-dropdown": "language-switch-dropdown",
  "language-switch-dropdown__chevron-icon": "language-switch-dropdown__chevron-icon",
  "language-switch-dropdown__open": "language-switch-dropdown__open",
  "language-switch-dropdown__list": "language-switch-dropdown__list",
  "language-switch-dropdown__button": "language-switch-dropdown__button",
  "language-switch-dropdown__list-item": "language-switch-dropdown__list-item",
  "language-switch-dropdown__link": "language-switch-dropdown__link",
  "language-switch-dropdown__link--selected": "language-switch-dropdown__link--selected"
};
export {
  n as default
};
